export default __webpack_public_path__ + "static/relative-book-bold-a20e952d1473c21316d5c04a9d38e2da.woff";